import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { toast } from 'sonner';
import Honeybadger from '@honeybadger-io/js';

import { LOGIN } from '../../../shared/constants';
import { SUCCESS_MESSAGES } from '../constants';
import { unlock as apiUnlock } from '../services/unlockService';

const useUnlock = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const unlockToken = searchParams.get('unlock_token');

  useEffect(() => {
    const unlock = async () => {
      try {
        await apiUnlock(unlockToken);

        const { description, title } = SUCCESS_MESSAGES.unlock.confirm;
        toast.success(title, { description });

        navigate(LOGIN);
      } catch (error) {
        setError({ code: error.code || '', message: error.message });
        Honeybadger.notify(error);
      } finally {
        setIsLoading(false);
      }
    };

    unlock();
  }, [navigate, unlockToken]);

  return { error, isLoading };
};

export default useUnlock;
